import React, { Component } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Multiselect } from "multiselect-react-dropdown";
import "./Physician.css";
import { tokenVerification } from "./Utils";

class Physician extends Component {
  constructor() {
    super(...arguments);
    this.multiselectRef = React.createRef();
    this.state = {
      dataStartedProcessing: false,
      userEmailId: "",
      options: [
        { name: "Option 1", id: 1 },
        { name: "Option 2", id: 2 },
      ],
      dontOverLap: false,
      selectedHealthSystemId: "",
      selectedHospitalId: "",
      selectedServiceLineId: "",
      showLoader: "",
      healthSystemId: "",
      hospitalId: "",
      serviceLineId: "",
      languages: [],
      nativeValue: [],
      value: [],
      editedBooleanValue: false,
      procedureData: "",
      selectedTreatmentNames: [],
      selectedTreatments: [],
      showProviderTreatment: false,
      editSelectedTreatmnt: false,
      selectedTreatmentRecord: {},
      disableSaveChangesButton: true,
      data: [
        {
          id: "",
          userName: "",
          userPhoneNumber: "",
          userEmailId: "",
          selectedTreatments: [],
        },
      ],
      editedData: {
        id: "",
        userName: "",
        userPhoneNumber: "",
        userEmailId: "",
        designation: "",
        comments: ""

      },
      dataFields: { text: "treatmentName", value: "treatmentId" },
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      hidden: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,
      userRoleId: "",
      paginationValue: 10,
      healthSystemNameIdArray: [],
      hospitalGroupValue: [],
      serviceLineGroupValue: [],
      dummyUUID: "00000000-0000-0000-0000-000000000000",
      noMatchingData: false,
      isLoading: true,
      searchTerm: "",
      isMailEditorModalOpen: false,
      emailContent: "You have got an invitation to join MyJEEVA Admin Portal as PROVIDER. To join the project, please click the button below.",

    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.procedureVar = [];
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    this.healthSystemDropDownInPhysicianRef = React.createRef();
    this.hospitalDropDownInPhysicianRef = React.createRef();
    this.serviceLineDropDownInPhysicianRef = React.createRef();
  }

  componentDidMount() {
    var thisController = this;
    thisController.state.selectedHealthSystemId =
      localStorage.getItem("healthSystemId");
    thisController.state.selectedHospitalId =
      localStorage.getItem("hospitalId");
    thisController.state.selectedServiceLineId =
      localStorage.getItem("serviceLineId");

    //var userRole = thisController.userDetails["userRole"];

    if (window.SCOPE_VALUE.CURRENT <= window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) {
      thisController.state.selectedHealthSystemId =
        thisController.userDetails["healthSystemId"];
    }

    if (window.SCOPE_VALUE.CURRENT <= window.SCOPE_VALUE.HOSPITAL_ADMIN) {
      thisController.state.selectedHospitalId =
        thisController.userDetails["hospitalId"];
    }

    if (window.SCOPE_VALUE.CURRENT <= window.SCOPE_VALUE.SERVICELINE_ADMIN) {
      thisController.state.selectedServiceLineId =
        thisController.userDetails["serviceLineId"];
    }
    thisController.setState(thisController.state);
    thisController.fetchHealthSystemDetails();
  }

  // addRow = () => {
  //   var addController = this;
  //   addController.state.editedId = "-1";
  //   addController.state.addRow = true;
  //   //  addController.refreshData();
  //   addController.state.paginationValue =
  //     addController.state.paginationValue + 5;
  //   addController.state.data = [];
  //   if (addController.state.pageNum != 0) {
  //     addController.setState({ pageNum: 0 });
  //   }

  //   addController.setState(addController.state);
  //   let prevData = [
  //     {
  //       id: "",
  //       name: "",
  //       phoneNumber: "",
  //       emailId: "",
  //     },
  //     ...this.state.data,
  //   ];
  //   addController.fetchProviders();
  //   setTimeout(() => {
  //     addController.setState({
  //       noMatchingData: false,
  //       editedId: "-1",
  //       disabled: true,
  //     });
  //   });
  // };

  addRow = () => {
    var addController = this;
    addController.state.editedId = "-1";
    addController.state.addRow = true;
    addController.state.paginationValue = addController.state.paginationValue + 5;
    if (addController.state.pageNum != 0) {
      addController.setState({ pageNum: 0 });
    }
    this.state.data.unshift({
      id: "",
      name: "",
      phoneNumber: "",
      emailId: "",
    });

    this.setState({
      noMatchingData: false,
      editedId: "-1",
      data: this.state.data,
      disabled: true,
    })

  };
  fetchProviders = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    var serviceLineId;

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PROCEDURE_ADMIN"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    }
    if (serviceLineId == null || serviceLineId == "null") {
      serviceLineId = thisController.state.dummyUUID;
    }
    if (hospitalId == null || hospitalId == "null") {
      hospitalId = thisController.state.dummyUUID;
    }
    $.ajax({
      url: "/my-jeeva-api/provider",
      method: "GET",
      data: {
        role: "PHYSICIAN",
        healthSystemId: healthSystemId,
        hospitalId: hospitalId,
        serviceLineId: serviceLineId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          // thisController.state.data = res.result;
          thisController.state.showLoader = false;
          thisController.state.disabled = false;

          var resData = res.result;
          // if (thisController.state.addRow) {
          //   resData = [
          //     {
          //       id: "",
          //       name: "",
          //       phoneNumber: "",
          //       emailId: "",
          //     },
          //     ...resData,
          //   ];

          //   thisController.state.addRow = false;
          // }
          thisController.state.data = resData;
          thisController.state.noMatchingData = false;
          thisController.state.isLoading = false;
          //thisController.refreshData();
          thisController.setState(thisController.state);
        } else {
          thisController.state.isLoading = false;
          thisController.state.noMatchingData = false
          thisController.state.showLoader = false;
          thisController.setState(thisController.state);
          // thisController.NotifyFailToLoad();
        }
      },
      error: function (xhr) {
        thisController.state.showLoader = false;
        thisController.setState(thisController.state);
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };

  CustomNoDataComponent = () => (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>There are no providers present. </p>
    </div>
  );

  configTreatment = (e, selectedRecord) => {
    this.state.selectedTreatmentNames = [];
    this.state.selectedTreatments = [];
    this.state.procedureVar = [];
    this.state.disableSaveChangesButton = true;
    this.setState(this.state);
    this.multiselectRef.current.resetSelectedValues();
    this.fetchProcedures();
    this.getProviderTreatments(e, selectedRecord);
  };

  inviteProvider = () => {
    var thisController = this;
    thisController.state.isInviteButtonClicked = true;
    thisController.setState(thisController.state);

    $.ajax({
      url: "/my-jeeva-api/invite-provider-admin",
      method: "POST",
      data: {
        id: localStorage.getItem("inviteeId"),
        emailContent: thisController.state.emailContent
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.refreshData();
        } else {
          thisController.state.isInviteButtonClicked = false;
          thisController.setState(thisController.state);
          console.log("Invitation failed");
        }
      },
      error: function (xhr) {
        thisController.state.showLoader = false;
        thisController.setState(thisController.state);
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }

  getProviderTreatments = (e, selectedRecord) => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var hospitalId;

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      hospitalId = document.getElementById("hospitalDropDown").value;
    } else if (userRole == "HOSPITAL_ADMIN") {
      hospitalId = thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PROCEDURE_ADMIN"
    ) {
      hospitalId = thisController.userDetails["hospitalId"];
    } else {
      hospitalId = thisController.state.selectedHospitalId;
    }
    var providerId = selectedRecord.id;
    // var serviceLineId = selectedRecord.serviceLineId
    $.ajax({
      url: "/my-jeeva-api/provider-treatments",

      method: "GET",
      data: {
        providerId: providerId,
        hospitalId: hospitalId,
        // serviceLineId: serviceLineId
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var data = [];
          for (var i = 0; i < res.result.length; i++) {

            data.push({ treatmentName: res.result[i].name });
            // var selectedData = {};
            // selectedData[res.result[i].name] = {
            //     id: res.result[i].id,
            //     treatmentName: res.result[i].treatmentName,
            //     treatmentId: res.result[i].treatmentId,
            // };
            // thisController.state.selectedTreatments.push(selectedData);
          }

          thisController.state.showProviderTreatment = true;
          thisController.state.selectedTreatmentNames = data;
          thisController.state.selectedTreatmentRecord = selectedRecord;
          thisController.state.editSelectedTreatmnt = false;
          thisController.setState(thisController.state);
        } else {
          // thisController.NotifyFailToLoad();
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  };

  notifyDataProcessing() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Hold on.Your data is saving...
      </b>,
      {
        position: "top-center",
      }
    );
  }

  NotifyFailToLoad() {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }
  editLanguages = () => {
    this.setState({ editedBooleanValue: true });
  };
  notifySelectHealthSystem() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Health System
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySelectHospital() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Hospital
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifySelectServiceLine() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select Service Line
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyImproperContactNumber() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid contact number
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyExistingAdmin() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;This admin is already present
      </b>,
      {
        position: "top-center",
      }
    );
  }

  saveUserApi(props, e) {
    var healthSystemId;
    var hospitalId;
    var serviceLineId;
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PROCEDURE_ADMIN"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    }
    if (healthSystemId == "Select Health System") {
      thisController.notifySelectHealthSystem();
    } else if (hospitalId == "Select Hospital") {
      thisController.notifySelectHospital();
    } else if (serviceLineId == "Select Service Line") {
      thisController.notifySelectServiceLine();
    } else {
      props.userName = document
        .getElementById("adminName" + props.id)
        .innerText.trim();
      props.userPhoneNumber = document
        .getElementById("adminContactNumber" + props.id)
        .innerText.trim();
      props.userEmailId = document
        .getElementById("adminEmailId" + props.id)
        .innerText.trim();
      props.designation = document
        .getElementById("designation" + props.id)
        .innerText.trim();
      props.comments = document
        .getElementById("comments" + props.id)
        .innerText.trim();

      thisController.state.editedId = "-1";
      thisController.setState(thisController.state);

      var pattern = new RegExp(
        /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/
      );
      var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{5,15}$|^\(\d{3}\)\s\d{3}-\d{4}$/
      );
      //  new RegExp(/^\+?[1-9]\d{1,3}[-\s]?\d{3,4}[-\s]?\d{4}$/);
      var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);

      if (
        props.userName == "" ||
        props.userPhoneNumber == "" ||
        props.userEmailId == "" ||
        props.designation == ""
      ) {
        thisController.notifyMsgFieldEmpty();
      } else if (!namePattern.test(props.userName)) {
        thisController.notifyImproperName();
      } else if (!pattern.test(props.userEmailId)) {
        thisController.notifyImproperEmailId();
      } else if (props.userPhoneNumber.length > 17 || !contactNumberPattern.test(props.userPhoneNumber)) {
        thisController.notifyImproperContactNumber();
      } else {
        var procedureIds = "";
        var physicianComponet = this;
        thisController.state.dataStartedProcessing = true;
        thisController.setState(thisController.state);
        var timer = setInterval(function () {
          clearTimeout(timer);

          $.ajax({
            url: "/my-jeeva-api/provider-admin",

            method: "POST",
            data: {
              userName: props.userName,
              userPhoneNumber: props.userPhoneNumber,
              userEmailId: props.userEmailId,
              role: "PHYSICIAN",
              healthSystemId: healthSystemId,
              serviceLineId: serviceLineId,
              hospitalId: hospitalId,
              designation: props.designation,
              comments: props.comments,
            },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
              if (res.success === true) {
                thisController.state.dataStartedProcessing = false;
                thisController.setState(thisController.state);
                thisController.state.disabled = false;
                if (res.result.success == false) {
                  thisController.notifyResponse(res.result.result);
                  thisController.state.disabled = false;
                } else {
                  thisController.state.editedId = "-1";
                  thisController.state.editedBooleanValue = false;
                  thisController.fetchProviders();
                }
              } else {
                // thisController.NotifyFailToLoad();
              }
            },
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.href = "";
              }
            },
          });
        }, 2000);
      }
    }
  }

  handleFieldChange = (key, e) => {
    console.log(key, e.currentTarget.textContent);
    this.state.editedData[key] = e.currentTarget.textContent.trim();
    this.setState(this.state);
  }

  updateTreatment = (e) => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var hospitalId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      hospitalId = thisController.state.selectedHospitalId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      hospitalId = thisController.userDetails["hospitalId"];
    } else if (userRole == "SERVICELINE_ADMIN") {
      hospitalId = thisController.userDetails["hospitalId"];
    } else {
      hospitalId = thisController.state.selectedHospitalId;
    }
    var data = [];
    for (
      var i = 0;
      i < thisController.state.selectedTreatmentNames.length;
      i++
    ) {
      var row = thisController.state.selectedTreatmentNames[i].treatmentName;
      var id, treatmentId, treatmentName;
      for (var j = 0; j < thisController.state.selectedTreatments.length; j++) {
        if (
          thisController.state.selectedTreatments[j][row] != undefined &&
          row == thisController.state.selectedTreatments[j][row].treatmentName
        ) {
          id = thisController.state.selectedTreatments[j][row].id;
          treatmentId =
            thisController.state.selectedTreatments[j][row].treatmentId;
          treatmentName =
            thisController.state.selectedTreatments[j][row].treatmentName;
        }
      }
      var providerTreatment;
      if (id == "null") {
        providerTreatment = {
          providerId: thisController.state.selectedTreatmentRecord.id,
          treatmentId: treatmentId,
          treatmentName: treatmentName,
          providerName: thisController.state.selectedTreatmentRecord.userName,
          hospitalId: hospitalId,
        };
      } else {
        providerTreatment = {
          id: id,
          providerId: thisController.state.selectedTreatmentRecord.id,
          treatmentId: treatmentId,
          treatmentName: treatmentName,
          providerName: thisController.state.selectedTreatmentRecord.userName,
          hospitalId: hospitalId,
          // serviceLineId: thisController.state.selectedTreatmentRecord.serviceLineId
        };
      }
      data.push(providerTreatment);
    }

    var providerTreatmentModel = {
      data: data,
      hospitalId: hospitalId,
      providerId: thisController.state.selectedTreatmentRecord.id,
      // serviceLineId: thisController.state.selectedTreatmentRecord.serviceLineId
    };

    $.ajax({
      url: "/my-jeeva-api/provider-treatment",

      method: "POST",
      contentType: "application/json; charset=utf-8",
      // dataType: 'json',
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: JSON.stringify(providerTreatmentModel),
      success: function (res) {
        if (res.success === true) {
          thisController.notifyTreatmentAdded();
          thisController.getProviderTreatments(
            e,
            thisController.state.selectedTreatmentRecord
          );
        } else {
          thisController.notifyFailedToUpdate(res.result);
        }
        thisController.setState({ editSelectedTreatmnt: false });
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/login";
        }
      },
    });
    // }
  };
  notifyResponse(response) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;
        {response}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  checkExistingAdminWhileUpdating(props) {
    var editedPhoneNuumber = document
      .getElementById("adminContactNumber" + props.id)
      .innerText.trim();
    var editedEmailId = document
      .getElementById("adminEmailId" + props.id)
      .innerText.trim();
    var count = 0;
    for (let i = 0; i < this.state.data.length; i++) {
      if (
        this.state.data[i].userPhoneNumber == editedPhoneNuumber &&
        this.state.data[i].userEmailId == editedEmailId
      ) {
        count = count + 1;
      }
      if (count >= 2) {
        this.notifyExistingAdmin();
        return false;
      }
    }
    return true;
  }

  updatePhysician = (props, e) => {
    var editedData = this.state.editedData;
    var healthSystemId;
    var hospitalId;
    var serviceLineId;
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PROCEDURE_ADMIN"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    }
    if (healthSystemId == "Select Health System") {
      thisController.notifySelectHealthSystem();
    } else if (hospitalId == "Select Hospital") {
      thisController.notifySelectHospital();
    } else if (serviceLineId == "Select Service Line") {
      thisController.notifySelectServiceLine();
    } else {
      props.userName = document
        .getElementById("adminName" + props.id)
        .textContent.trim();
      props.userPhoneNumber = document
        .getElementById("adminContactNumber" + props.id)
        .textContent.trim();
      props.userEmailId = document
        .getElementById("adminEmailId" + props.id)
        .textContent.trim();
      props.designation = document
        .getElementById("designation" + props.id)
        .textContent.trim();
      props.comments = document
        .getElementById("comments" + props.id)
        .textContent.trim();


      var pattern = new RegExp(
        /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/
      );
      var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{5,15}$|^\(\d{3}\)\s\d{3}-\d{4}$/
      );
      // new RegExp(/^\+?[1-9]\d{1,3}[-\s]?\d{3,4}[-\s]?\d{4}$/);
      var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
      if (
        editedData.userName == "" ||
        editedData.userPhoneNumber == "" ||
        editedData.userEmailId == "" ||
        editedData.designation == ""
      ) {
        thisController.notifyMsgFieldEmpty();
      } else if (!namePattern.test(editedData.userName)) {
        thisController.notifyImproperName();
      } else if (!pattern.test(editedData.userEmailId)) {
        thisController.notifyImproperEmailId();
      } else if (editedData.userPhoneNumber.length > 17 || !contactNumberPattern.test(editedData.userPhoneNumber)) {
        thisController.notifyImproperContactNumber();
      } else {
        var saveData = {
          ...editedData,
          userRole: "PHYSICIAN",
          healthSystemId: healthSystemId,
          serviceLineId: serviceLineId,
          hospitalId: hospitalId,
          procedureId: thisController.state.dummyUUID,
          targetId: thisController.state.dummyUUID
        };
        if (thisController.checkExistingAdminWhileUpdating(props)) {
          $.ajax({
            url: "/my-jeeva-api/provider",

            method: "PATCH",
            data: JSON.stringify(saveData),
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
            },
            success: function (res) {
              if (res.success === true) {
                if (res.result.success == false) {
                  thisController.notifyResponse(res.result.result);
                  thisController.state.disabled = false;
                } else {
                  // thisController.notifyUpdate();
                  thisController.state.disabled = false;
                  thisController.state.editedId = "-1";
                  thisController.state.editedBooleanValue = false;
                  thisController.fetchProviders();
                }
              } else {
                thisController.notifyFailedToUpdate(res.result);
                thisController.state.disabled = false;
              }
              thisController.setState(thisController.state);
            },
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.href = "/my-jeeva/login";
              }
            },
          });
        }
      }
    }
  };
  notifyImproperName() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;Please provide a valid name</b>, {
      position: "top-center"
    });
  }

  notifyFailedToDelete(message) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      &nbsp;&nbsp;{message}</b>, {
      position: "top-center"
    });
  }
  notifyImproperEmailId() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a valid email id
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedToUpdate(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  deletePhysicianDetails = (props) => {
    let physiciandata = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (props.id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      physiciandata.splice(props.id, 1);
    } else {
      var deleteData = {
        id: props.id,
        emailId: props.userEmailId,
        userRole: "PHYSICIAN",
        healthSystemId: deleteApiViewController.state.selectedHealthSystemId,
        hospitalId: deleteApiViewController.state.selectedHospitalId,
        serviceLineId: deleteApiViewController.state.selectedServiceLineId,
      }
      $.ajax({
        url: "/my-jeeva-api/delete-user",

        method: "POST",
        data: JSON.stringify(deleteData),
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': "application/json"
        },
        success: function (res) {
          if (res.success === true) {
            physiciandata.splice(props.id, 1);
            deleteConstructorVariables.state.data = [];
            deleteApiViewController.state.disabled = false;
            deleteConstructorVariables.setState(
              deleteConstructorVariables.state
            );
            deleteConstructorVariables.fetchProviders();
            deleteConstructorVariables.refreshData();
          } else {
            deleteApiViewController.notifyFailedToDelete(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  makeCelledit(props, e) {
    // this.markAsBeingEdited(this.state.data[props.id].id);
    // this.refreshData();
    this.setRowDataToState(props);
    this.setState({ editedId: props.id });
  }

  setRowDataToState = (row) => {

    var data = this.state.editedData;
    console.log("Before adding data ", data);

    for (const key in data) {
      data[key] = row[key];
    }
    console.log("After adding data ", data);
    this.setState({ editedData: data });
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  notifyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Provider details updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyEmptyFieldForAdd() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }

  fetchProcedures = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    var serviceLineId;

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PROCEDURE_ADMIN" ||
      userRole == "PATIENT"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    }
    if (hospitalId == "null") {
      hospitalId = "00000000-0000-0000-0000-000000000000";
    }
    if (serviceLineId == "null") {
      serviceLineId = "00000000-0000-0000-0000-000000000000";
    }
    thisController.state.selectedTreatments = [];
    thisController.setState(thisController.state);

    $.ajax({
      url: "/my-jeeva-api/procedure",

      method: "GET",
      data: {
        serviceLineId: serviceLineId,
        healthSystemId: healthSystemId,
        hospitalId: hospitalId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          thisController.procedureVar = [];
          var activeProcedures = res.result;
          activeProcedures = activeProcedures.filter(procedure => !procedure.isDeactivated);
          for (var i = 0; i < activeProcedures.length; i++) {
            thisController.procedureVar.push({
              treatmentName: activeProcedures[i].name,
            });
            var selectedData = {};
            selectedData[activeProcedures[i].name] = {
              id: "null",
              treatmentName: activeProcedures[i].name,
              treatmentId: activeProcedures[i].id,
            };
            thisController.state.selectedTreatments.push(selectedData);
          }

          thisController.setState(thisController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/";
        }
      },
    });
  };

  refreshTreatmentData = (e) => {
    e.preventDefault();
    var thisController = this;
    thisController.state.editSelectedTreatmnt = true;
    thisController.state.selectedTreatmentNames = [];
    thisController.state.procedureVar = [];
    thisController.setState(thisController.state);
    thisController.multiselectRef.current.resetSelectedValues();
    thisController.fetchProcedures();
    thisController.getProviderTreatments(
      e,
      thisController.state.selectedTreatmentRecord
    );
  };

  refreshData = (e) => {
    // e.preventDefault();
    this.setState({
      disabled: false,
      editedId: "-1",
      isLoading: true,
      noMatchingData: false,
      data: [],
      searchTerm: "",
    });
    this.fetchProviders();
  };

  notifyAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Provider details added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyTreatmentAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Provider treatment updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Provider detail deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e });
  };

  notifyFailedDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;All Mlts have been deleted Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyNodata(response) {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Please Select the provider role
      </b>,
      {
        position: "top-center",
      }
    );
  }

  rolehandleChange = () => {
    let valueOfuserRoleId = document.getElementById("userRole").value;
    this.state.userRoleId = valueOfuserRoleId;

    this.fetchProviders();
  };

  fetchHealthSystemDetails = () => {
    var thisController = this;
    var responseData = [];
    var userRole = thisController.userDetails["userRole"];

    if (userRole == "PROCEDURE_ADMIN" || userRole == "PATIENT") {
      thisController.state.healthSystemId =
        thisController.userDetails["healthSystemId"];
    } else {
      $.ajax({
        url: "/my-jeeva-api/health-system",

        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            responseData = res.result;
            var totalCount = responseData.length;
            thisController.state.healthSystemNameIdArray = [];
            for (var i = 0; i < totalCount; i++) {
              thisController.state.healthSystemNameIdArray.push({
                name: res.result[i].name,
                value: res.result[i].id,
              });
            }
            thisController.setState(thisController.state);

            if (!thisController.state.selectedHealthSystemId) {
              if (totalCount > 0) {
                thisController.state.selectedHealthSystemId = res.result[0].id;
                thisController.state.selectedHospitalId = null;
                thisController.state.selectedServiceLineId = null;
              } else {
                thisController.state.hospitalGroupValue = [];
                thisController.state.data = [];
              }
            }
            thisController.setState(thisController.state);

            var selectBox =
              thisController.healthSystemDropDownInPhysicianRef.current;
            if (selectBox && selectBox.selectedIndex >= 0) {
              console.log(
                "The current Health System is :" +
                selectBox.options[selectBox.selectedIndex].innerText
              );
              thisController.onHealthSystemChange({ target: selectBox });
            }
            thisController.fetchHospitalDetails();
          } else {
            thisController.state.showLoader = false;
            thisController.setState(thisController.state);
            thisController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            tokenVerification();
          }
        },
      });
    }
  };

  fetchHospitalDetails() {
    var thisController = this;
    var responseData = [];
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "PROCEDURE_ADMIN" ||
      userRole == "PATIENT"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      thisController.state.hospitalId =
        thisController.userDetails["hospitalId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
    }

    $.ajax({
      url: "/my-jeeva-api/hospital",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: healthSystemId,
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.hospitalGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.hospitalGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }
          thisController.setState(thisController.state);

          if (!thisController.state.selectedHospitalId) {
            if (totalCount > 0) {
              thisController.state.selectedHospitalId = res.result[0].id;
              thisController.state.selectedServiceLineId = null;
            } else {
              thisController.state.serviceLineGroupValue = [];
              thisController.state.data = [];
            }
          }
          thisController.setState(thisController.state);

          var selectBox = thisController.hospitalDropDownInPhysicianRef.current;
          if (selectBox && selectBox.selectedIndex >= 0) {
            console.log(
              "The current Hospital is :" +
              selectBox.options[selectBox.selectedIndex].innerText
            );
            thisController.onHospitalChange({ target: selectBox });
          }
          thisController.fetchServiceLineDetails();
        } else {
          thisController.state.showLoader = false;
          thisController.setState(thisController.state);
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr, status, error) {
        thisController.state.showLoader = false;
        thisController.setState(thisController.state);
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }

  fetchServiceLineDetails() {
    var thisController = this;
    var responseData = [];
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
    } else if (
      userRole == "HOSPITAL_ADMIN" ||
      userRole == "PROCEDURE_ADMIN" ||
      userRole == "PATIENT"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
    }
    if (hospitalId == "null") {
      hospitalId = "00000000-0000-0000-0000-000000000000";
    }
    $.ajax({
      url: "/my-jeeva-api/service-line",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        healthSystemId: healthSystemId,
        hospitalId: hospitalId,
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.showLoader = true;
          thisController.setState(thisController.state);
          responseData = res.result;
          var totalCount = responseData.length;
          thisController.state.serviceLineGroupValue = [];
          for (var i = 0; i < totalCount; i++) {
            thisController.state.serviceLineGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }
          thisController.setState(thisController.state);
          if (!thisController.state.selectedServiceLineId) {
            if (totalCount > 0) {
              thisController.state.selectedServiceLineId = res.result[0].id;
            } else {
              thisController.state.selectedServiceLineId = null;
              thisController.state.data = [];
            }
            var selectBox = thisController.serviceLineDropDownInPhysicianRef.current;
            if (selectBox && selectBox.selectedIndex >= 0) {
              console.log(
                "The current service line is :" +
                selectBox.options[selectBox.selectedIndex].innerText
              );
              thisController.onServiceLineChange({ target: selectBox });
            }
          }
          thisController.fetchProviders();
          thisController.setState(thisController.state);
        } else {
          thisController.state.showLoader = false;
          thisController.setState(thisController.state);
          thisController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr, status, error) {
        thisController.state.showLoader = false;
        thisController.setState(thisController.state);
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "";
        }
      },
    });
  }

  onHealthSystemChange = (e) => {
    var selectBox = e.target;
    this.state.dontOverLap = true;
    this.state.isLoading = true;
    if (this.state.selectedHealthSystemId != selectBox.value) {
      this.state.selectedHospitalId = null;
      localStorage.setItem(`hospitalName`, null);
      localStorage.setItem("serviceName", null);
      localStorage.setItem("hospitalId", null);
    }

    this.state.selectedHealthSystemId = selectBox.value;
    localStorage.setItem("healthSystemId", this.state.selectedHealthSystemId);
    var healthSystemName = selectBox.options[selectBox.selectedIndex].innerText;
    localStorage.setItem("healthSystemName", healthSystemName);
    this.setState(this.state);
    window.adminNavigationBar.paintHeading();
    this.fetchHospitalDetails();
  };

  onHospitalChange = (e) => {
    var selectBox = e.target;
    this.state.dontOverLap = true;
    this.state.isLoading = true;
    if (this.state.selectedHospitalId != selectBox.value) {
      this.state.selectedServiceLineId = null;
      localStorage.setItem("serviceName", null);
      localStorage.setItem("serviceLineId", null);
    } else {
      console.log(
        "Selected Hospital ID=" +
        this.state.selectedHospitalId +
        " which is same as the current selection which is:" +
        selectBox.value
      );
    }
    this.state.selectedHospitalId = selectBox.value;
    var hospitalName = selectBox.options[selectBox.selectedIndex].innerText;
    localStorage.setItem("hospitalId", this.state.selectedHospitalId);
    localStorage.setItem("hospitalName", hospitalName);
    this.setState(this.state);
    window.adminNavigationBar.paintHeading();
    this.fetchServiceLineDetails();
  };

  onServiceLineChange = (e) => {
    var selectBox = e.target;
    this.state.isLoading = true;
    this.state.dontOverLap = true;
    this.state.selectedServiceLineId = selectBox.value;
    var serviceLineName = selectBox.options[selectBox.selectedIndex].innerText;
    localStorage.setItem("serviceLineId", this.state.selectedServiceLineId);
    localStorage.setItem("serviceName", serviceLineName);
    this.setState(this.state);
    window.adminNavigationBar.paintHeading();
    this.fetchProviders();
  };
  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyTemplateSaved() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Template is saved.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  enableMultiSelect = (e) => {
    e.preventDefault();
    this.setState({ editSelectedTreatmnt: true });
  };

  openDeletePopUp = (row) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: `Are you sure you want to delete ${row.userName} ?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deletePhysicianDetails(row),
        },
        {
          label: "No",
        },
      ],
    });
  };

  handleTreatmentSelect = (selectedList, selectedItem) => {
    var thisController = this;
    thisController.state.disableSaveChangesButton = false;
    thisController.state.selectedTreatmentNames = selectedList;
    thisController.setState(thisController.state);
  };

  handleTreatmentRemove = (selectedList, selectedItem) => {
    var thisController = this;
    thisController.state.disableSaveChangesButton = false;
    thisController.state.selectedTreatmentNames = selectedList;
    thisController.setState(thisController.state);
  };
  checkTreatmentName = (e) => {
    this.state.disableSaveChangesButton = true;
    this.setState(this.state);
    var treatmentName = e;
    var treatmentNameFromOptions = [];

    for (var i = 0; i < this.procedureVar.length; i++) {
      treatmentNameFromOptions.push(this.procedureVar[i].treatmentName);
    }
    console.log("The treatmentName options are : " + treatmentNameFromOptions);

    console.log("The typed treatmentName is : " + e);

    console.log(treatmentNameFromOptions.includes(e));
    if (treatmentNameFromOptions.includes(e)) {
      this.state.disableSaveChangesButton = false;
      this.setState(this.state);
    }
  };
  handleChangeOfUserEmailId(e) {
    this.state.userEmailId = e.target.value;
    this.setState(this.state);
  }

  caseInsensitiveSort = (field) => (rowA, rowB) => {
    const a = rowA[field] ? rowA[field].toLowerCase() : '';
    const b = rowB[field] ? rowB[field].toLowerCase() : '';

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  handleSearch = (event) => {
    var thisController = this;
    thisController.state.searchTerm = event.target.value;
    thisController.state.isLoading = true;
    thisController.state.data = [];
    thisController.setState(thisController.state);

    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    var serviceLineId;

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.state.selectedServiceLineId;
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PROCEDURE_ADMIN"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
      serviceLineId = thisController.userDetails["serviceLineId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
      serviceLineId = thisController.state.selectedServiceLineId;
    }
    if (serviceLineId == null || serviceLineId == "null") {
      serviceLineId = thisController.state.dummyUUID;
    }
    if (hospitalId == null || hospitalId == "null") {
      hospitalId = thisController.state.dummyUUID;
    }

    $.ajax({
      url: "/my-jeeva-api/search-providers-data",
      method: "GET",
      data: {
        healthSystemId: healthSystemId,
        hospitalId: hospitalId,
        serviceLineId: serviceLineId,
        role: "PHYSICIAN",
        searchTerm: thisController.state.searchTerm
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          if (res.result.length > 0) {
            thisController.state.data = [];
            thisController.state.noMatchingData = false;
            thisController.state.isLoading = false;
            thisController.setState(thisController.state);
            thisController.state.data = res.result;
            thisController.setState(thisController.state);
          } else {
            thisController.state.noMatchingData = true;
            thisController.state.isLoading = false;
            thisController.setState(thisController.state);
          }
        }
      },
      error: function (xhr) {

      },
    });

  };

  renderHtmlEditor = (row) => {
    localStorage.setItem("inviteeId", row.id);
    this.state.isMailEditorModalOpen = true;
    this.state.emailContent = "";
    this.setState(this.state);
    this.fetchMailTemplate();
  };


  handleEmailContentChange = (e) => {
    this.setState({ emailContent: e.target.value });
  };

  sendEmail = () => {
    this.state.isMailEditorModalOpen = false;
    this.setState(this.state);
    this.inviteProvider();
  };

  saveMailTemplate = () => {
    var thisController = this;
    var userRole = thisController.userDetails["userRole"];
    var healthSystemId;
    var hospitalId;
    var userId = thisController.userDetails["userId"];

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.state.selectedHospitalId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PROCEDURE_ADMIN"
    ) {
      healthSystemId = thisController.userDetails["healthSystemId"];
      hospitalId = thisController.userDetails["hospitalId"];
    } else {
      healthSystemId = thisController.state.selectedHealthSystemId;
      hospitalId = thisController.state.selectedHospitalId;
    }

    if (hospitalId == null || hospitalId == "null") {
      hospitalId = thisController.state.dummyUUID;
    }

    var saveData = {
      role: "PHYSICIAN",
      emailContent: thisController.state.emailContent,
      healthSystemId: healthSystemId,
      hospitalId: hospitalId,
      userId: userId
    };

    $.ajax({
      url: "/my-jeeva-api/save-email-template",
      method: "POST",
      contentType: "application/json; charset=utf-8",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: JSON.stringify(saveData),
      success: function (res) {
        if (res.success === true) {
          thisController.notifyTemplateSaved();
          thisController.fetchMailTemplate();
        } else {
          console.log("Email template save is failed");
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/login";
        }
      },
    });

  }

  fetchMailTemplate = () => {
    var thisController = this;
    var userId = thisController.userDetails["userId"];
    var userRole = thisController.userDetails["userRole"];
    var hospitalId;

    if (userRole == "HEALTHSYSTEM_ADMIN") {
      hospitalId = thisController.state.selectedHospitalId;
    } else if (userRole == "HOSPITAL_ADMIN") {
      hospitalId = thisController.userDetails["hospitalId"];
    } else if (
      userRole == "SERVICELINE_ADMIN" ||
      userRole == "PROCEDURE_ADMIN"
    ) {
      hospitalId = thisController.userDetails["hospitalId"];
    } else {
      hospitalId = thisController.state.selectedHospitalId;
    }

    if (hospitalId == null || hospitalId == "null") {
      hospitalId = thisController.state.dummyUUID;
    }

    $.ajax({
      url: "/my-jeeva-api/fetch-email-template",
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        role: "PHYSICIAN",
        userId: userId,
        hospitalId: hospitalId
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.emailContent = res.result.emailContent
          thisController.setState(thisController.state);
        } else {
          thisController.state.emailContent = "You have got an invitation to join MyJEEVA Admin Portal as PROVIDER. To join the project, please click the button below.";
          thisController.setState(thisController.state);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/my-jeeva/login";
        }
      },
    });

  }

  cancelEdit = () => {
    this.state.isMailEditorModalOpen = false;
    this.setState(this.state);
  };

  clearSearchData = () => {
    var thisController = this;
    thisController.setState({ searchTerm: "" }, () => {
      thisController.fetchHealthSystemDetails();
    });
}

  render() {
    const columns = [
      {
        name: <b style={{ fontSize: "16px" }}>Name</b>,
        // width: "200px",
        sortable: true,
        sortFunction: this.caseInsensitiveSort('userName'),
        selector: (row) => (
          <div name="adminName">
            <div
              className="textarea"
              name="userName"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              onInput={(e) => this.handleFieldChange("userName", e)}
              id={"adminName" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.userName}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Contact Number</b>,
        // width: "200px",
        sortable: true,
        sortFunction: this.caseInsensitiveSort('userPhoneNumber'),
        selector: (row) => (
          <div name="adminContactNumber">
            <div
              className="textarea"
              name="userPhoneNumber"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              onInput={(e) => this.handleFieldChange("userPhoneNumber", e)}
              id={"adminContactNumber" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.userPhoneNumber}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Email ID</b>,
        // width: "290px",
        sortable: true,
        sortFunction: this.caseInsensitiveSort('userEmailId'),
        selector: (row) => (
          <div name="adminEmailId">
            <div
              className="textarea"
              name="userEmailId"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == ""
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "noneonInput={ this.handleFieldChange}",
              }}
              onInput={(e) => this.handleFieldChange("userEmailId", e)}
              id={"adminEmailId" + row.id}
              // contentEditable={
              //   !(row.id == "" ? false 
              //   :
              //    row.id != this.state.editedId
              //    )

              //     ? "plaintext-only"
              //     : false
              // }

              contentEditable={row.id == "" ? true : false}

            >
              {row.userEmailId}
            </div>
          </div>
        ),
      },
      {
        name: <b style={{ fontSize: "16px" }}>Position</b>,
        // width: "290px",
        sortable: true,
        sortFunction: this.caseInsensitiveSort('designation'),
        selector: (row) => (
          <div name="designation">
            <div
              className="textarea"
              name="designation"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              onInput={(e) => this.handleFieldChange("designation", e)}
              id={"designation" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.designation}
            </div>
          </div>
        ),
      },

      {
        name: <b style={{ fontSize: "16px" }}>Comments</b>,
        // width: "300px",
        sortable: true,
        sortFunction: this.caseInsensitiveSort('comments'),
        selector: (row) => (
          <div name="comments">
            <div
              className="textarea"
              name="comments"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "100%",
                border:
                  row.id == "" || row.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: row.id == "" ? "2px" : "none",
              }}
              onInput={(e) => this.handleFieldChange("comments", e)}
              id={"comments" + row.id}
              contentEditable={
                !(row.id == "" ? false : row.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {row.comments}
            </div>
          </div>
        ),
      },

      {
        name: <b style={{ fontSize: "16px" }}>Actions</b>,
        width: "400px",
        selector: (row) => (
          <div id="action">
            {(!row.isAccepted) &&
              <button
                className="btn2 table-action-button"
                style={{
                  marginRight: "10px",
                  display: row.id == "" ? "none" : "inline-flex",
                }}
                onClick={(e) => {
                  {
                    !row.isAccepted &&
                      this.renderHtmlEditor(row);
                  }
                }}
              >
                {!row.isInvited ?
                  "Invite" : "Re-invite"
                }
              </button>}
            <button
              className="btn2 table-action-button "
              style={{
                marginRight: "10px",
                display: row.id == "" ? "none" : "inline-flex",
              }}
              onClick={(e) => {
                this.configTreatment(e, row);
              }}
            >
              Assign Treatment
            </button>

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "-6px",
              }}
            >
              <img
                className="img-responsive"
                title={
                  row.id == "" || row.id == this.state.editedId
                    ? "Save"
                    : "Edit"
                }
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                src={
                  row.id == ""
                    ? this.saveImageSrc
                    : row.id != this.state.editedId
                      ? this.editImageSrc
                      : this.saveImageSrc
                }
                onClick={(e) => {
                  this.state.dataStartedProcessing
                    ? this.notifyDataProcessing()
                    : row.id == ""
                      ? this.saveUserApi(row, e)
                      : row.id == this.state.editedId
                        ? this.updatePhysician(row, e)
                        : this.makeCelledit(row, e);
                }}
              />
            </button>
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginLeft: "-6px",
              }}
              title="Delete"
            >
              <img
                className="img-responsive"
                src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                onClick={() =>
                  row.id === ""
                    ? this.fetchProviders()
                    : this.openDeletePopUp(row)
                }
              />
            </button>
          </div>
        ),
      },
    ];
    return (
      <div style={{ marginRight: "1%" }} id="physician">
        <div
          style={{
            background: "#F9F9FB",
            display: "block",
          }}
        >
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> My JEEVA | Providers </title>
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          <link rel="stylesheet" href="assets/css/material.css" />
          <link rel="stylesheet" href="assets/css/buttonForm.css" />

          <div className="row" style={{ marginLeft: "14px" }}>
            <div className="col-sm-1">
              <h6
                className="nav-item"
                style={{ color: "#282a65", marginTop: "1vh" }}
              >
                Provider{" "}
              </h6>
            </div>
            <div className="col-sm-9" Align="right"
              style={{
                marginLeft: "-16.2vw", paddingTop: "2.2rem"
              }}
            >
              <label
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Health System
              </label>
              <select
                value={this.state.selectedHealthSystemId}
                id="healthSystemDropDownInPhysicianPage"
                className="healthSystem"
                onChange={(e) => this.onHealthSystemChange(e)}
                placeholder="Select Health System"
                ref={this.healthSystemDropDownInPhysicianRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN
                      ? "inline"
                      : "none",

                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.healthSystemNameIdArray.map((healthSystem) => (
                  <option value={healthSystem.value}>
                    {healthSystem.name}
                  </option>
                ))}
              </select>
              <label
                style={{
                  marginLeft: "3vh",
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HOSPITAL_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Hospital
              </label>

              <select
                value={this.state.selectedHospitalId}
                // defaultValue="Select Hospital"
                id="hospitalDropDown"
                className="hospital"
                onChange={(e) => this.onHospitalChange(e)}
                placeholder="Select hospital"
                ref={this.hospitalDropDownInPhysicianRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.HOSPITAL_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.hospitalGroupValue.map((hospitalGroup) => (
                  <option value={hospitalGroup.value}>
                    {hospitalGroup.name}
                  </option>
                ))}
              </select>

              <label
                style={{
                  marginLeft: "3vh",
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                      ? "inline"
                      : "none",
                }}
              >
                Service Line
              </label>
              <select
                value={this.state.selectedServiceLineId}
                id="serviceLine"
                className="hospital"
                onChange={(e) => this.onServiceLineChange(e)}
                placeholder="Select serviceline"
                ref={this.serviceLineDropDownInPhysicianRef}
                style={{
                  display:
                    window.SCOPE_VALUE.CURRENT >
                      window.SCOPE_VALUE.SERVICELINE_ADMIN
                      ? "inline"
                      : "none",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                  width: "13vw",
                  marginLeft: "10px",
                }}
              >
                {this.state.serviceLineGroupValue.map((serviceLineGroup) => (
                  <option value={serviceLineGroup.value}>
                    {serviceLineGroup.name}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{ marginLeft: "1.5vw", marginTop: "3.30vh" }}>
              <input
                type="text"
                style={{
                  width: "10vw",
                  border: "1px solid #777676",
                  borderRadius: "3px",
                  padding: "10px",
                  height: "0.6vw",
                  paddingRight: "2rem",
                }}
                value={this.state.searchTerm}
                onChange={this.handleSearch}
                placeholder="Search ..."
              />
              {this.state.searchTerm && (
                <span
                  onClick={() => this.clearSearchData()}
                  style={{
                    // position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#777676",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    lineHeight: 1,
                    userSelect: "none",
                    marginLeft: "-1vw"
                  }}
                >
                  ×
                </span>
              )}
            </div>
            <div className="col-sm-2 " style={{
              marginTop: "3px",
              // marginLeft: "-1vw" 
            }}>
              <div className="d-flex flex-row-reverse pt-2">
                <div className="p-2" style={{ marginBottom: "10px" }}>
                  <button
                    className="btn action-button"
                    id="addMsg"
                    title=" Add "
                    onClick={
                      this.state.disabled
                        ? this.notifyMsgFieldEmpty
                        : this.addRow
                    }
                  >
                    <img src="assets/images/add_white_24dp.png" />
                  </button>
                  <button
                    title="Refresh"
                    onClick={this.refreshData}
                    type="button"
                    className="btn action-button"
                  >
                    <img src="./assets/images/refresh_white_24dp.png"></img>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {this.state.isMailEditorModalOpen &&

            <div
              className="modal"
              style={{
                display: "block",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <div
                className="modal-dialog"
                id="center-aligned-account-modal"
                style={{ marginTop: "-12rem", marginLeft: "15rem" }}>

                <div
                  className="modal-content"
                  style={{
                    height: "auto",
                    marginTop: "17vw",
                    width: "40vw",
                    marginLeft: "16vw",
                    borderRadius: "10px", border: "2px solid #282a65"
                  }}
                  Align="center"
                >
                  <div className="modal-header noBorder">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      id="close_id"
                      onClick={this.cancelEdit}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                      >
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        <path d="M0 0h24v24H0z" fill="none" />
                      </svg>
                    </button>
                  </div>
                  <h4 style={{
                    color: "#282a65"
                  }}>Invitation Email Template</h4>
                  <div className="html-editor">
                    <textarea
                      style={{ borderRadius: "10px", border: "2px solid #282a65" }}
                      value={this.state.emailContent}
                      onChange={this.handleEmailContentChange}
                      rows="10"
                      cols="50"
                    />
                    <div className="editor-actions">
                      <button className="btn2 table-action-button" onClick={this.saveMailTemplate}>Save template</button>
                      <button className="btn2 table-action-button" onClick={this.sendEmail}>Send Invitation</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }


          <div className="row" style={{ textAlign: "left" }}>
            <div className="col-lg-12 ">
              {!this.state.noMatchingData &&
                <div className="card">
                  {this.state.isLoading && (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                      <p>Loading ...</p>
                    </div>
                  )}
                  {!this.state.isLoading && this.state.data.length === 0 && (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                      <p>There are no providers present.</p>
                    </div>
                  )}
                  {(!this.state.isLoading && this.state.data.length > 0) && (
                    <DataTable
                      columns={columns}
                      data={this.state.data}
                      pagination={this.state.paginationValue}
                      fixedHeaderScrollHeight="400px"
                      noDataComponent={<this.CustomNoDataComponent />}
                    />
                  )}
                </div>
              }
              <ToastContainer className="Toast-at-center" />
            </div>
          </div>
          <div className='card'>
            {this.state.noMatchingData &&
              <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                <p>No matching options found ...</p>
              </div>
            }
          </div>
          <div
            className="modal"
            style={{
              display: this.state.showProviderTreatment ? "block" : "none",
            }}
          >
            <div className="modal-dialog" id="center-aligned-account-modal">
              <div
                className="modal-content"
                style={{ height: "600px", width: "900px" }}
              >
                <div className="modal-header noBorder">
                  <div className="row">
                    <div className="col-sm-12" align="center"></div>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    id="close_id"
                    onClick={() => {
                      this.setState({
                        showProviderTreatment: false,
                        editSelectedTreatmnt: false,
                      });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </button>
                </div>
                <div className="modal-body" style={{ overflowY: 'scroll' }}>
                  <form>
                    <div className="row">
                      <div className="col-sm-10" style={{ marginRight: "0px" }}>
                        <h4
                          className="nav-item"
                          style={{
                            color: "#282a65",
                            marginTop: "20px",
                            textAlign: "center",
                          }}
                        >
                          Treatments administered by{" "}
                          {this.state.selectedTreatmentRecord.userName}
                        </h4>
                        <div
                          style={{
                            display:
                              this.state.editSelectedTreatmnt == true
                                ? "none"
                                : "block",
                            marginTop: "3.5em",
                            overflowY: "scroll",
                            maxHeight: "44vh"
                          }}
                          align="center"
                          id="appearance-for-selected-languages"
                        >
                          {this.state.selectedTreatmentNames.map(
                            (selectedTreatment) => (
                              <span>
                                <button disabled={true} className="bubble">
                                  {selectedTreatment.treatmentName}
                                </button>
                                <br />
                              </span>
                            )
                          )}
                        </div>
                        <div
                          style={{
                            display:
                              this.state.editSelectedTreatmnt == true
                                ? "block"
                                : "none",
                            margin: "5em 3em",
                          }}
                        >
                          <Multiselect
                            options={this.procedureVar}
                            displayValue="treatmentName"
                            closeIcon="cancel"
                            placeholder="Select Treatment"
                            selectedValues={this.state.selectedTreatmentNames}
                            preSelectedValues={
                              this.state.selectedTreatmentNames
                            }
                            className="multiSelectContainer"
                            onSelect={this.handleTreatmentSelect}
                            onRemove={this.handleTreatmentRemove}
                            onSearch={(e) => this.checkTreatmentName(e)}
                            ref={this.multiselectRef}
                          />
                        </div>
                        <div
                          className="col-sm-10"
                          align="center"
                          style={{
                            display:
                              this.state.selectedTreatmentNames.length == 0 &&
                                this.state.editSelectedTreatmnt == false
                                ? "block"
                                : "none",
                            padding: "15%",
                            marginLeft: "15%",
                            border: "1px solid #949494",
                            borderRadius: "10px",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "22px",
                              color: "black",
                            }}
                          >
                            No treatments added yet!
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn btn-primary pull-right navyblue-btn"
                          style={{ width: "auto", fontSize: "14px" }}
                          hidden={!this.state.editSelectedTreatmnt}
                          onClick={this.updateTreatment}
                          disabled={this.state.disableSaveChangesButton}
                        >
                          Save Changes
                        </button>
                      </div>
                      <button
                        className="btn action-button"
                        style={{ marginTop: "40px" }}
                        title="Add or Remove Treatment"
                        onClick={this.enableMultiSelect}
                        hidden={this.state.editSelectedTreatmnt}
                      >
                        <img
                          className="img-responsive cursor-change"
                          src="./assets/images/editWithWhiteFilled.png"
                        />
                      </button>
                      <button
                        className="btn action-button"
                        style={{ marginTop: "40px", marginLeft: "0px" }}
                        title="Refresh"
                        onClick={this.refreshTreatmentData}
                      >
                        <img src="./assets/images/refresh_white_24dp.png" />
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Physician;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Physician.js